<template>
  <div @click="Close()" class="bannerconfirmation-popup" v-bind:style="{display: toggled ? 'inline-block' : 'none'}"
       v-if="toggled">
    <div class="background" v-on:click="Close()"></div>
    <div class="employee-type-table">
      <div class="header">
        <div class="label">{{ $t('pages.comp.infoConfirmations') }}</div>
      </div>
      <div class="header">
        <div class="label-small">{{ banner.description }}</div>
      </div>
      
      <div class="table-container">
        <div>
        <p>{{banner.text}}</p>
      </div>
        <datatable :state="confirmationTableState"/>
      </div>
      <div v-if="loading" class="loading-md bannerconfirmation bg">
        <i class="fas fa-spinner"></i>
        <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
          {{ loadingText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datatable from '../../uicomponents/datatable.vue';
import {mapState, mapGetters} from 'vuex';
import VueEventBus from '../../../vue-event-bus';

export default {
  name: 'bannerconfirmation',
  components: {
    datatable,
  },
  data() {
    return {
      loading: true,
      loadingText: this.$t('pages.comp.loadingConfirmations'),
      toggled: false,
      banner: {description: ''},
      activeEmployees: [],
      selectedEmployees: [],
      storeBannerConfirmations: [],
      storeBannerConfirmationMap: {},
      confirmationTableState: {}
    }
  },
  created: function () {
    VueEventBus.$on("toggle-bannerconfirmation", this.Toggle);
  },
  mounted: function () {
    this.$helpers.log(this, 'mounted', null);
  },
  beforeDestroy() {
    VueEventBus.$off("toggle-bannerconfirmation", this.Toggle);
  },
  computed: {
    ...mapGetters([
      'spotMap'
    ]),
  },
  watch: {
    storeId(newVal, oldVal) {
      this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      this.loading = true;
      this.$helpers.log(this, 'refresh');

      this.loadStoreBannerConfirmations()
          .then(response => {
            view.updateStoreBannerConfirmations(response.data)
            this.recalculateTableState();
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error)
          });
    },


    Close() {
      this.Toggle(false);
    },
    Toggle(val, banner, activeEmployees, selectedEmployees) {
      if (val !== undefined || val !== null) {
        this.toggled = val;
      } else {
        this.toggled = !this.toggled;
      }
      this.banner = banner;
      console.log(this.banner)
      this.SetActiveEmployees(activeEmployees);
      this.SetSelectedEmployees(selectedEmployees);
      if (this.toggled) {
        this.refresh();
      }
    },
    SetActiveEmployees(val) {
      if (val !== undefined || val !== null) {
        this.activeEmployees = val;
      }
    },
    SetSelectedEmployees(val) {
      if (val !== undefined || val !== null) {
        this.selectedEmployees = val;
      }
    },
    Init(parent) {
      this.toggled = true;
      this.refresh(true);
    },
    recalculateTableState() {
      let view = this;
      let state = {};
      let emps = this.activeEmployees;
      
      let tableEmployees = [];

      emps.forEach(emp => {
        let confirmation = this.storeBannerConfirmations.find(conf => conf.employeeId === emp.id)
        let empname = emp.firstName + " " + emp.lastName;
        
        let date = '';
        let confirmed = false;
        if (confirmation !== undefined) {
          date = this.$helpers.getMomentFromStringTZ(confirmation.timestamp).format('lll');
          confirmed = true;
        }
        let applicableToEmployee = false;
        if(this.selectedEmployees.length > 0){
          applicableToEmployee = this.selectedEmployees.includes(emp.id);
        } else {
          let empSpot = emp.spotId ? this.spotMap[emp.spotId] : null;
          applicableToEmployee = (this.banner.spotId == null || this.banner.spotId == emp.spotId) 
                               && ((empSpot == null && this.banner.employeeLevels.includes(1)) || (empSpot != null && this.banner.employeeLevels.includes(empSpot.employeeLevel)));
        
        }

        if(confirmed || applicableToEmployee){
           tableEmployees.push({
            'name': empname,
            'confirmed': confirmed,
            'date': date
          });
        }
       
      });

      state = this.$helpers.GetDataTableStateFromKeyLabelObject({
        name: this.$tc('global.general.employee'),
        confirmed: this.$t('global.ui.approved'),
        date: this.$t('store.settings.date')
      }, tableEmployees);

      state.headerMap['name'].sort = false;
      state.headerMap['name'].align = 'center';
      state.headerMap['name'].alignHeaderLabel = 'center';
      state.headerMap['name'].DisplayLabel = (i) => {
        return i.name;
      };

      state.headerMap.confirmed.componentTypeRow = 'checkbox';
      state.headerMap.confirmed.align = 'center';
      state.headerMap.confirmed.componentStateBuilder = (conf) => {
        return {
          propContainer: {value: conf.confirmed, data: conf}
        };
      };

      state.headerMap['date'].sort = false;
      state.headerMap['date'].align = 'center';
      state.headerMap['date'].alignHeaderLabel = 'center';
      state.headerMap['date'].DisplayLabel = (i) => {
        return i.date;
      };

      this.confirmationTableState = state;
    },
    loadStoreBannerConfirmations: function () {
      let view = this;
      let url = '/api/sec/bannerconfirmation';
      let params = {
        storeId: this.$store.state.storeId,
        bannerId: this.banner.id
      };


      return this.axios({
        method: 'get',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url
      })
    },
    updateStoreBannerConfirmations: function (data) {
      let tbannerconfirmations = [];
      let tMap = {};
      for (let i = 0; i < data.length; i++) {
        tbannerconfirmations.push(data[i]);
        tMap[data[i].id] = data[i];

      }
      this.storeBannerConfirmations = tbannerconfirmations;
      this.storeBannerConfirmationMap = tMap;
    },
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.header.top {
  margin: 10px 0;
}

.data-table {
  position: relative;
}

.bannerconfirmation-popup {
  position: fixed;
  display: inline-block;
  height: calc(100vh - 155px);
  overflow: none;
  width: 700px;
  border-radius: 5px;
  z-index: 1000;
  background: var(--bg);
  box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.2);
  padding: 0px;
  border: 1px solid #a5a5a5;

  bottom: 45px;
  right: 100px;
}

.bannerconfirmation-popup .header {
  padding: 0 24px;
  text-align: right;
  float: right;
  height: 56px;
  width: 100%;
  border-bottom: solid 1px var(--md);
  display: flex;
  justify-content: flex-end;
}

.bannerconfirmation-popup .header .label {
  text-align: right;
  color: var(--md);
  font-size: 24px;
  font-family: DistrictProBook;
  display: flex;
  align-items: center;
  height: 100%;
}

.bannerconfirmation-popup .header .label-small {
  text-align: right;
  color: var(--md);
  font-size: 20px;
  font-family: DistrictProBook;
  display: flex;
  align-items: center;
  height: 100%;
}

.bannerconfirmation-popup .table-container {
  height: calc(100vh - 270px);
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.background {
  position: fixed;
  height: 100vh;
  width: 100vw;
  left: 0;
  right: 0;
  z-index: -1;
  top: 0;
}

.loading-md.bannerconfirmation .fa-spinner {
  position: absolute;
  top: 200px;
  left: 320px;
  margin-right: auto;
  margin-left: auto;
  width: 60px;
  height: 60px;
  font-size: 60px;
  color: var(--md);
  animation-name: spin;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  overflow: hidden !important;
}

.loading-md.bannerconfirmation .loading-text {
  position: absolute;
  top: 320px;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 24px;
  width: 100%;
  overflow: hidden !important;
  text-align: center;
  font-size: 24px;
  color: var(--md);
  font-family: DistrictProBook;
}
</style>
